// extracted by mini-css-extract-plugin
export default {"root":"RegionCard_root__-fkTv","header":"RegionCard_header__k2GLj","radioGroup":"RegionCard_radioGroup__raGCv","list":"RegionCard_list__jM9oG"};